import React, {useEffect, useState} from "react";

import './recording-table.scss'
import {useRecoilValue} from "recoil";
import {grpcCustomerServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow
} from "@carbon/react";
import PropTypes from "prop-types";
import moment from "moment";

const RecordingTable = ({dateRef}) => {
  const systemService = useRecoilValue(grpcCustomerServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [recs, setRecs] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(25)
  const [totalSize, setTotalSize] = useState(0)

  const headers = [{
    key: 'running', header: '',
  },{
    key: 'username', header: 'Utente',
  }, {
    key: 'systemname', header: 'Sistema',
  }, {
    key: 'systemtype', header: 'Tipo sistema',
  }, {
    key: 'startedat', header: 'Avviata il',
  }, {
    key: 'closedat', header: 'Spenta il',
  }, {
    key: 'durationseconds', header: 'Durata (min)',
  }, {
    key: 'notes', header: 'Note',
  }];

  useEffect(() => {
    const req = new proto.api.ListRecordingsRequest()
    const pageReq = new proto.api.PageRequest()
    pageReq.setPage(page)
    pageReq.setSize(size)
    pageReq.setSort("running desc, updated_at desc")
    req.setPagination(pageReq)
    req.setFromDate(moment(dateRef).startOf("day").startOf("month").format("DD/MM/YYYY hh:mm:ss"))
    req.setToDate(moment(dateRef).endOf("day").endOf("month").format("DD/MM/YYYY hh:mm:ss"))
    systemService.listRecordings(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const respObj = resp.toObject()
        setRecs(respObj.recordingsList)
        setTotalSize(respObj.pagination.total)
      }
      setLoading(false)
    })
  }, [size, page, dateRef]);

  if (loading) {
    return (<DataTableSkeleton
      columnCount={headers.length + 1}
      rowCount={5}
      headers={headers}
    />)
  }

  if (error) {
    return (
      <div>
        <span>ERROR!</span>
      </div>
    )
  }

  const handlePaginationChange = (newPage, newPageSize) => {
    if (newPageSize !== size) {
      setSize(newPageSize);
    }
    if (newPage !== page) {
      setPage(newPage)
    }
  }

  const processChildren = (cell) => {
    switch (cell.info.header) {
      case 'running': {
        return (
          <div title={cell.value ? "In corso" : "Terminata"} className={cell.value ? "light green" : "light grey"}/>
        )
      }
      case 'durationseconds': {
        return (
          <span title="Durata (minuti)">
            {Math.round(Number(cell.value) / 60)}
          </span>
        )
      }
      default: {
        return (
          <>
            {cell.value}
          </>
        )
      }
    }
  }

  return (
    <DataTable
      rows={recs}
      headers={headers}
      render={({
                 rows,
                 headers,
                 getHeaderProps,
                 getRowProps,
                 getTableProps,
                 getTableContainerProps,
               }) => {
        return (
          <TableContainer title="Lista rendicontazioni"
                          description="Storico delle rendicontazioni registrate per i sistemi" {...getTableContainerProps()}>
            <Pagination
              totalItems={totalSize}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={size}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} {...getRowProps({row})}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {processChildren(cell)}
                      </TableCell>
                    ))}
                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>);
      }}
    />
  )
}

RecordingTable.propTypes = {
  dateRef: PropTypes.object.isRequired,
}

export default RecordingTable